var _rect, _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBankSc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 23,
    viewBox: "0 0 32 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 23,
    rx: 3,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.7601 19.2195L12.0905 14.8771C12.0905 14.8771 11.2539 14.3963 11.0625 13.5006C10.7935 12.2424 11.6803 11.1641 11.6803 11.1641L20.3365 16.8015C21.004 17.2366 21.1864 18.1268 20.7572 18.7984C20.3162 19.4885 19.4101 19.6405 18.7601 19.2195Z",
    fill: "#38D200"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.4435 10.2337C12.4435 10.2337 11.4219 9.61682 11.4219 8.19003C11.4219 6.76804 12.4431 6.15887 12.4431 6.15887L16.0893 3.7725C16.7577 3.33792 17.6515 3.52767 18.0859 4.1958C18.5204 4.86404 18.3308 5.75801 17.6624 6.19242L14.5893 8.19344L19.8255 11.6037C19.8255 11.6037 20.768 12.1438 20.9536 13.0552C21.2129 14.3269 20.3376 15.3748 20.3376 15.3748L12.4435 10.2337Z",
    fill: "#0473EA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.3028 6.70313C18.9605 6.70313 18.7166 6.81108 18.479 6.96583L16.6992 8.12511L18.479 9.28434C18.7191 9.43909 18.9709 9.54721 19.3029 9.54721C20.0882 9.54721 20.7249 8.91039 20.7249 8.12511C20.7249 7.33989 20.0881 6.70295 19.3028 6.70313Z",
    fill: "#38D200"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.422 19.4535C12.7643 19.4535 13.0081 19.3455 13.2458 19.1908L15.0258 18.0315L13.2458 16.8723C13.0057 16.7177 12.7539 16.6094 12.422 16.6094C11.6367 16.6094 11 17.2461 11 18.0315C11 18.8166 11.6367 19.4536 12.422 19.4535Z",
    fill: "#0473EA"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBankSc);
export default __webpack_public_path__ + "static/media/BankSC.cfee2881bef04f56478911f2984c87a6.svg";
export { ForwardRef as ReactComponent };